import { BaseItem } from '../common';
import {
  BaseDocumentTemplate as BaseDocumentTemplate_,
  Category,
  Command,
  DataSource,
  Font,
  PointReference,
} from '../document/template';

export type { Command as TextCommand };
export { Category, DataSource, Font, PointReference };

export enum DocumentCondition {
  NewPatient = 'NEW_PATIENT',
  ExistingPatient = 'EXISTING_PATIENT',
  NotSignedThisCalendarYear = 'NOT_SIGNED_THIS_CALENDAR_YEAR',
  Always = 'ALWAYS',
  Never = 'NEVER',
}

interface BaseDocumentTemplate extends Omit<BaseDocumentTemplate_, 'deleted'> {
  isDeleted: boolean;
  deletedTimestamp: Date | null;
  previsitFormTemplateId: string;
  documentTemplateId: string;
}

export interface DocumentTemplate extends BaseItem, BaseDocumentTemplate {}

export type CreateValues = Omit<
  BaseDocumentTemplate,
  'documentTemplateId' | 'isDeleted' | 'deletedTimestamp'
>;
export type UpdateValues = Partial<CreateValues>;

export interface DocumentTemplateWithProviders extends DocumentTemplate {
  providerUserIds: string[];
}
